/**
 * range
 * Returns an array filled with numbers between two values
 * @param {number} begin - start value
 * @param {number} end - end value
 * @returns {array} the resulting array
 */
export const range = (begin, end) => {
	let result = [];
	for (let i = begin; i <= end; ++i){
		result.push(i);
	}
	return result;
};

/**
 * @name deduplicateByKey
 * @description Deduplicates objects in an array according to their key
 * @param {Array} items - The original error collection to be deduped
 * @param {string} keyPropertyName - The name of the property by which objects should be compared
 * @returns {Array} A shallow copy of the errors array, sans duplicates
 */
export const deduplicateByKey = (items, keyPropertyName) =>{
	// Can't use a set here because we are using objects
	var uniqueKeys = {};
	items.forEach(x => uniqueKeys[x[keyPropertyName]] = x);
	return Object.keys(uniqueKeys).map(key => uniqueKeys[key]);// babel does not support Object.values yet...
};



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/value.js